import { Ability, subject } from "@casl/ability"
import { URLS } from '../utils/url'
import { ApiCaller } from '../utils/api'

class PermissionService {
  constructor() {
    this.ability = new Ability();
  }

  async setPermissions() {
    const response = await ApiCaller().get(URLS.USER_PROFILE())
    let rules = []
    let account_type = response.data.account_type
    response.data.permissions.forEach(permission => {
      let action = (account_type === 'clinic_master') ? 'write_all' : Object.values(permission)[0]
      rules.push({ action: action, subject: Object.keys(permission)[0] })

      const relatedPermissions = this.buildRelatedPermissions(Object.values(permission)[0], Object.keys(permission)[0], account_type)
      rules = rules.concat(relatedPermissions)
    })
    this.ability.update(rules)
  }

  buildRelatedPermissions(action, subject, account_type) {
    let rules = []

    if (account_type === 'clinic_master' || account_type === 'staff_master') {
      if (action === 'write_all') {
        rules.push({ action: 'read_all', subject: subject })
      }
    }
    else {
      if (action === 'write') {
        rules.push({ action: 'read', subject: subject })
      }

      if (action === 'read_all') {
        rules.push({ action: 'read', subject: subject })
        rules.push({ action: 'write', subject: subject })
      }

      if (action === 'write_all') {
        rules.push({ action: 'read', subject: subject })
        rules.push({ action: 'write', subject: subject })
        rules.push({ action: 'read_all', subject: subject })
      }
    }

    return rules
  }

  can(action, subject) {
    return this.ability.can(action, subject);
  }
}

const permissionService = new PermissionService();
export default permissionService;
